<template>
    <div id="empty">
        <div class="head-tool">
            <span @click="$router.go(-1)"><i class="el-icon-arrow-left"></i> 返回</span>
            <!--<span class="tr" @click="$router.push('/')">首页</span>-->
        </div>

        <div class="tip">
            <p class="t" v-if="!finish">已读完最新章节，作者努力码字中～</p>
            <p class="p" v-if="!finish">正常情况下每日更新1-5章，敬请期待</p>
            <p class="t" v-if="finish">小说以完结，您已读完全部内容！</p>
            <p class="p" v-if="finish">快来看看其他书吧~</p>
        </div>


        <div class="recommend">
            <h3>精选好书</h3>
            <ul class="two">
                <router-link :to="{name:'Book',params:{wid:item.wid}}" v-for="item in two" tag="li">

                    <el-image :src="'http://static.yuread.cn/' + item.h_cover +'!thumb'" ></el-image>
                    <div >
                        <p>{{item.title}}</p>

                    </div>
                </router-link>

            </ul>

            <h3>飙升好书</h3>
            <ul class="three">
                <router-link :to="{name:'Book',params:{wid:item.wid}}" v-for="item in three" tag="li">

                    <el-image :src="'http://static.yuread.cn/' + item.h_cover +'!thumb'" class="fl"></el-image>
                    <div class="fl info">
                        <p class="title">{{item.title}}</p>
                        <p class="desc">{{item.sort_description}}</p>
                        <p class="author">{{item.author}}</p>
                    </div>
                </router-link>

            </ul>
        </div>
        <transition name="custom-classes-transition" enter-active-class="animated bounceInDown" leave-active-class="animated bounceOutUp">

            <div  class="special" v-show="special" @click="special=false">
                <div class="xian-box">
                    <span class="xian"></span>
                    <span class="dian"></span>
                </div>
                <router-link tag="div" class="book" :to="{name:'Book',params:{wid:one.wid}}">
                    <img :src="'http://static.yuread.cn/' + one.h_cover" alt="">
                    <p class="tl">{{one.title}}</p>
                    <p class="tr">{{one.author}}</p>
                </router-link>

            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: "Empty",
        data(){
            return {
                recommend : [],
                intellect : [],
                tagsRecommend : [],
                finish : this.$route.query.finish || 0,
                sex : this.$route.query.sex || 1,
                cunzai : [],
                special : false,
                specialInfo : {
                    bookid : '',
                    cover : '',
                    title : '',
                    author : ''
                },
                one : {},
                two : [],
                three : []
            }
        },
        computed : {
            getRecommend(){
                let recommend = [];
                this.recommend.forEach(v =>{
                    if(v.sex == this.sex){
                        recommend.push(v);
                    }
                })
                return recommend;
            },
            getTagsBook(){
                let books = [];
                this.tagsRecommend.forEach(v => {
                    if(this.cunzai.indexOf(v.wid) > -1){

                    }else{
                        books.push(v)
                    }
                })
                return books;
            },
            getUserInfo(){
                return this.$store.getters.getUserInfo;
            },
        },
        methods : {
            doCollection(type){
                if(this.getUserInfo.id > 0){
                    this.axios.post('/api/collection/doCollection',{
                        bid : this.$route.params.wid,
                        type : type,
                    }).then(r =>{
                        let data = r.data;
                        if(data.code == 1){
                            this.$message.success(data.msg)
                        }else{
                            this.$message.error(data.msg)
                        }
                    })
                }else{
                    if(confirm("请先登录后操作！")){
                        this.$router.push({name:"Login",query:{cburl:this.$route.path}});
                    }
                }
            },
            getRecommendList(){
                this.axios.post('/api/recommend/getRecommendList',{
                    rid : 11
                }).then(r => {
                    let data = r.data;
                    if(data.code){
                        this.recommend = data.data;
                    }

                })
            },
            getTagsRecommend() {
                this.axios.post('/api/recommend/getTagsRecommend',{
                    bookid : this.$route.params.wid
                }).then(r =>{
                    if(r.data.code){
                        this.tagsRecommend = r.data.data;
                    }
                })
            } ,
            getIntellectRecommend(){
                this.axios.post('/api/recommend/emptys',{
                    bookid : this.$route.params.wid
                }).then(r =>{
                    if(r.data.code){
                        this.one = r.data.data.one;
                        this.two = r.data.data.two;
                        this.three = r.data.data.three;
                        this.special = true;

                    }

                })
            },
            getSpecial(){
                let user = this.getUserInfo;
                if(user.id > 0){
                    this.axios.post('/api/recommend/getSpecialEmpty',{
                        bookid : this.$route.params.wid
                    }).then(r => {
                        if(r.data.code){
                            this.specialInfo.cover = 'http://static.yuread.cn/' + r.data.data.h_cover;
                            this.specialInfo.bookid = r.data.data.wid;
                            this.specialInfo.title = r.data.data.title;
                            this.specialInfo.author = r.data.data.author;
                            this.special = true;
                        }
                    })
                }
            }
        },
        created(){
            this.getIntellectRecommend();
            // this.getSpecial();

        }
    }
</script>

<style lang="less">
#empty{background: #f6f7f9;height: 100%;
    .head-tool{display: flex;padding: 26px 20px;
        span{flex:1;font-size: 30px;color:#333;
            i{font-size: 30px;}
        }
    }
    .tip{text-align: center;
        .t{font-size: 28px;}
        .p{font-size: 24px;color: #666;}
    }

    .recommend{width: 670px;background: #fff;border-radius: 20px;margin:40px auto;padding:40px;
        h3{font-size: 28px;font-weight: 400;color: #333;margin-bottom: 20px;

        }
        .two{display: flex;flex-direction: row;justify-content: space-between;
            li{width: 170px;}
        }
        .three{overflow: auto;
            li{width: 100%;overflow: auto;margin-bottom: 40px;}
            .el-image{width: 140px;height:196px;margin-right: 40px;}
            .info{width: 410px;padding-top: 20px;}
            .title{font-size: 32px;}
            .desc{font-size: 26px;color: #666;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2; margin-bottom: 20px;}
            .author{color: #999;font-size: 24px;}



        }
    }

    .special{position:fixed;top: 0;left: 0;right:0;bottom:0;z-index: 999;

        .xian-box{height: 310px;
            .xian{background:#ededed;display: block;margin:0 auto;height: 350px;width: 8px;z-index: 9999;position: relative;top:-50px;border-radius: 0 0 20px 20px;box-shadow: 3px 3px 3px #666;}
            .dian{background: #999;display: block;margin:0 auto;height: 20px;width: 20px;border-radius: 50%;z-index: 9991;position:relative;top:-60px;}
        }

        .book{width: 400px;height: 600px;margin:-30px auto;text-align: center;border-radius: 20px;overflow: hidden;background: #fff;box-shadow: 5px 5px 10px #000;
            img{width: 100%;height: 500px;display: block;}
            p{color: #666;font-size: 30px;padding: 10px 20px;line-height: 30px;}
            .tr{font-size: 24px;color: #999}

        }
    }
}
</style>
